export const queryFilters = {
    codingEventsFilters: {
        codingEvents: {
            accountId: 0,
            assignedToId: 0,
            eventPriorityId: 0,
            queueId: 0,
            statusId: 0,
            searchText: '',
            searchId: 0,
            requestedServiceId: 0,
            lineOfBusinessId: 0,
            currentPage: 0,
            take: 20,
            skip: 0,
            showCustomerQueue: false,
            showTeamQueue: false,
            showMyQueue: false,
            fetchRefData: true
                },
        teamQueue: {
            accountId: 0,
            assignedToId: 0,
            eventPriorityId: 0,
            queueId: 0,
            statusId: 0,
            searchText: '',
            searchId: 0,
            requestedServiceId: 0,
            lineOfBusinessId: 0,
            currentPage: 0,
            take: 20,
            skip: 0,
            showCustomerQueue: false,
            showTeamQueue: true,
            showMyQueue: false,
            fetchRefData: true
                },
        myQueue: {
            accountId: 0,
            assignedToId: 0,
            eventPriorityId: 0,
            queueId: 0,
            statusId: 0,
            searchText: '',
            searchId: 0,
            requestedServiceId: 0,
            lineOfBusinessId: 0,
            currentPage: 0,
            take: 20,
            skip: 0,
            showCustomerQueue: false,
            showTeamQueue: false,
            showMyQueue: true,
            fetchRefData: true
                },
        account: {
            accountId: 0,
            assignedToId: 0,
            eventPriorityId: 0,
            queueId: 0,
            statusId: 0,
            searchText: '',
            searchId: 0,
            requestedServiceId: 0,
            lineOfBusinessId: 0,
            currentPage: 0,
            take: 20,
            skip: 0,
            showCustomerQueue: true,
            showTeamQueue: false,
            showMyQueue: false,
            fetchRefData: true
        }
    }
};